import type { SVGProps } from 'react'

export const ZaiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="26" height="26" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.0605 9.14844C14.9758 11.351 16.6684 13.1424 18.8184 14.1875C16.6684 15.2324 14.9759 17.0241 14.0605 19.2266C13.1452 17.0241 11.4525 15.2325 9.30273 14.1875C11.4526 13.1424 13.1454 11.351 14.0605 9.14844ZM4.69141 4.84961C5.43076 6.2791 6.6016 7.44199 8.03711 8.17578C6.60169 8.90947 5.43086 10.0727 4.69141 11.502C3.95182 10.0725 2.7805 8.90944 1.34473 8.17578C2.78059 7.44201 3.95191 6.27936 4.69141 4.84961ZM11.3828 1.87793C11.6481 2.2433 11.9703 2.56422 12.3369 2.82812C11.9705 3.09187 11.648 3.41223 11.3828 3.77734C11.1177 3.41241 10.796 3.09175 10.4297 2.82812C10.7962 2.56435 11.1176 2.24312 11.3828 1.87793Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
)
